<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="3002401">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'arriveTime'">
                <span>{{ scope.row[scope.column.property] / 100 }}</span>
              </section>
              <section v-else-if="scope.column.property === 'userName'">
                <span
                  >{{ scope.row.userName }}（{{ scope.row.userPhone }}）</span
                >
              </section>
              <section v-else>{{ scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '3002402',
                    showCondition:
                    scope.row.agingJurisdiction ==true && (scope.row.agingSts !== null && scope.row.agingSts < 2),
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve'),
                  },
                  {
                    permpisions: '3002402',
                    showCondition:
                    scope.row.appealJurisdiction ==true && (scope.row.agingSts === 3 &&
                        scope.row.appealSts !== null &&
                        scope.row.appealSts < 2) ,
                    name: '审核',
                    event: () => toDetail(scope.row, 'apply'),
                  },
                  {
                    permpisions: '3002403',
                    showCondition: scope.row.agingSts === 0,
                    name: '修改',
                    event: () => toEdit(scope.row.agingId),
                  },
                  {
                    showCondition: scope.row.agingSts === 0,
                    name: '查看',
                    event: () => toDetail(scope.row),
                  },
                  {
                    permpisions: '3002404',
                    showCondition: true,
                    name: '取消',
                    event: () => cancel(scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
    </section>
  </qx-card>
</template>

<script>
import TableBtn from 'components/tableBtn/tableBtn';
import tableMixin from '@qx/mixin/table';
import {
  orderTimeCarrierList,
  orderTimeCancel,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn,
  },
  data () {
    return {
      searchBoxData: {
        // orderId: this.$route.query.id,
        // selectType: 1,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'lineNode',
            label: '路段',
          },
          {
            prop: 'orderStartDate',
            label: '离台时间',
          },
          {
            prop: 'orderArriveDate',
            label: '到达时间',
          },
          {
            prop: 'arriveTime',
            label: '运输时长',
          },
          {
            prop: 'arriveHourDouble',
            label: '到达时限',
          },
          {
            prop: 'finePriceDouble',
            label: '罚款金额(元)',
          },
          {
            prop: 'userName',
            label: '责任司机',
            w: 200,
          },
          {
            prop: 'agingStsName',
            label: '状态',
          },
          {
            prop: 'appealStsName',
            label: '申诉',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orderTimeCarrierList,
    handleBeforeGetData () {
      this.searchBoxData = {
        orderId: this.$route.query.id,
        selectType: 1,
      };
    },
    toEdit (id) {
      this.jump({
        label: id ? '修改承运方时效' : '新增承运方时效',
        url: `/manage/operate/order/deal/orderDetailTab/carrier/edit?orderId=${this.$route.query.id}${id ? '&id=' + id : ''}`,
      });
    },
    async cancel (id) {
      const confirmRes = await this.$confirm('是否确认取消该时效罚款？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await orderTimeCancel({
          id,
        });
        if (!res.failed) {
          this.$message.success('取消成功');
          this.getData();
        }
      }
    },
    toDetail (item, type = '') {
      let label = '审核承运方详情';
      if (type === 'apply') {
        label = '审核承运方申诉';
      } else if (type === 'approve') {
        label = '审核承运方审核';
      }
      this.jump({
        label,
        url: `/manage/operate/order/deal/orderDetailTab/detail?id=${item.agingId}&type=${type}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
